import * as React from 'react';

import classNames from 'classnames';

import {Card} from 'shells/card/card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {GetAccountEnrichment_accountEnrichment as EnrichmentField} from 'nutshell-graphql-types';

import {Info} from './info';

type Props = {
    label?: string;
    data: Array<EnrichmentField>;
    isShowingNew: boolean;
    hasBorder?: boolean;
    topPadding?: boolean;
};

export function DataSection(props: Props) {
    const {hasBorder = true, topPadding = true} = props;

    const getFieldValueToDisplay = (field: EnrichmentField) =>
        field.isNew && !props.isShowingNew ? undefined : field.value;

    const fieldListClassNames = classNames({
        'pad-16': topPadding,
        'px-16 pb-16': !topPadding,
    });

    return (
        <StackLegacy spacing={8}>
            {props.label && <UppercaseLabel>{props.label}</UppercaseLabel>}
            <Card hasBorder={hasBorder}>
                <div className={fieldListClassNames}>
                    {props.data &&
                        props.data.length > 0 &&
                        props.data.map(
                            (field) =>
                                field && (
                                    <Info
                                        key={field.label}
                                        label={field.displayLabel || field.label}
                                        value={getFieldValueToDisplay(field)}
                                        isNew={field.isNew}
                                    />
                                )
                        )}
                </div>
            </Card>
        </StackLegacy>
    );
}
